import { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Subtitle } from '../../../shared/components/subtitle/subtitle'
import map from '../../../assets/images/map.png'
import './intro-section.scss'
import { ProjectTriangle } from '../../../shared/components/FilterTable/components/ProjectTriangle'
import { COUNTRY_COLORS } from '../../../shared/constants/country-color'
import { CustomButton } from '../../../shared/components/CustomButton/CustomButton'

export default function IntroSection({ mDatoImage }: { mDatoImage: string }) {
  const { t }: any = useTranslation()

  const [isMobile, setIsMobile] = useState(
    window.matchMedia('(max-width: 768px)').matches
  )
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)')
    const handleChange = (e: any) => setIsMobile(e.matches)

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  const handleDownloadClick = () => {
    const fileName = `detras_negocio_litio_20260325.xlsx`
    const fileUrl = `/downloads/${fileName}`

    // Create a temporary anchor element to trigger download
    const link = document.createElement('a')
    link.href = fileUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <>
      <div className="intro">
        <h1 className="title">{t('title')}</h1>

        {isMobile && (
          <div className="map-image-container text-center">
            <img className="map mx-auto" src={mDatoImage} alt="Map" />
          </div>
        )}

        <div className="start-icon">
          <p className="description">
            <Trans i18nKey="description" />
          </p>

          <p className="last-update">
            <small>{t('lastUpdate')}</small>
          </p>
        </div>
      </div>

      <Subtitle text={t('filters.title')} />

      <div className="countries-section">
        <div className="start-icon">
          <p className="description">{t('filters.description')}</p>
        </div>

        <div className="countries-grid">
          <CustomButton
            to=""
            icon="download"
            customAction={handleDownloadClick}
            customClass="download"
          >
            {t('downloadData')}
          </CustomButton>
          <ul>
            <li>
              <ProjectTriangle size={10} fill={COUNTRY_COLORS.peru} />
              {t('countries.peru')}
            </li>
            <li>
              <ProjectTriangle size={10} fill={COUNTRY_COLORS.mexico} />
              {t('countries.mexico')}
            </li>
            <li>
              <ProjectTriangle size={10} fill={COUNTRY_COLORS.guyana} />
              {t('countries.guyana')}
            </li>
            <li>
              <ProjectTriangle size={10} fill={COUNTRY_COLORS.brazil} />
              {t('countries.brazil')}
            </li>
            <li>
              <ProjectTriangle size={10} fill={COUNTRY_COLORS.bolivia} />
              {t('countries.bolivia')}
            </li>
            <li>
              <ProjectTriangle size={10} fill={COUNTRY_COLORS.paraguay} />
              {t('countries.paraguay')}
            </li>
            <li>
              <ProjectTriangle size={10} fill={COUNTRY_COLORS.argentina} />
              {t('countries.argentina')}
            </li>
            <li>
              <ProjectTriangle size={10} fill={COUNTRY_COLORS.chile} />
              {t('countries.chile')}
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
